import { EDatasetStatus } from "types";

export const DATASET_STATUS_LABEL: Record<EDatasetStatus, string> = {
  [EDatasetStatus.READY]: "Ready",
  [EDatasetStatus.DRAFT]: "Draft",
  [EDatasetStatus.INDEXING]: "Indexing",
  [EDatasetStatus.READ_ONLY]: "Read Only",
  [EDatasetStatus.PARTIAL_INDEX]: "Partial Index",
  [EDatasetStatus.ERROR]: "Error",
};

export const DATASET_STATUS_TOOLTIP: Record<EDatasetStatus, string> = {
  [EDatasetStatus.READY]: "Dataset is ready. All actions are available.",
  [EDatasetStatus.DRAFT]: "Dataset is not built yet. Finish creating it first.",
  [EDatasetStatus.INDEXING]: "Dataset is being indexed. Wait for it to finish.",
  [EDatasetStatus.READ_ONLY]:
    "A task is running. You can explore, but not change the dataset.",
  [EDatasetStatus.PARTIAL_INDEX]:
    "New data is not indexed yet. Re-Index to use it in Label Propagation and training.",
  [EDatasetStatus.ERROR]:
    "The last task failed. Use Recover or Delete from the dataset menu.",
};
